module.exports = __webpack_public_path__ + "static/img/main.bf2187b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/1/main.png
// module id = Ff7A
// module chunks = 1